/* ==========================================================================
   Livingroom Builders · animaciones (GSAP + ScrollTrigger)
   - Se carga una sola vez aunque varias secciones incluyan este archivo.
   - Si GSAP no carga, la página se ve completa igual (nada arranca oculto).
   - En el editor de temas no oculta contenido y se reinicia al editar.
   ========================================================================== */
(function () {
  if (window.__bldBuilders) return;
  window.__bldBuilders = true;

  var GSAP_URL = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
  var ST_URL = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var mm = null;

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.async = false;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function ensureGsap() {
    if (window.gsap && window.ScrollTrigger) return Promise.resolve();
    var p = window.gsap ? Promise.resolve() : loadScript(GSAP_URL);
    return p.then(function () { return window.ScrollTrigger ? null : loadScript(ST_URL); });
  }

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* Encabezado sticky del tema: si existe, el teléfono se pega justo debajo */
  function syncStickyTop() {
    var root = document.querySelector('[data-bld-story]');
    if (!root || root.dataset.autoTop !== 'true') return;
    var header = document.querySelector('sticky-header, .site-header, header[role="banner"], .header-wrapper, #shopify-section-header, [id^="shopify-section-"][id*="header"]');
    if (!header) return;
    var pos = getComputedStyle(header).position;
    if (pos !== 'sticky' && pos !== 'fixed') return;
    var h = Math.round(header.getBoundingClientRect().height);
    if (h > 0 && h < 220) document.documentElement.style.setProperty('--bld-sticky-top', (h + 16) + 'px');
  }

  function init() {
    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    gsap.registerPlugin(ScrollTrigger);
    if (mm) mm.revert();
    syncStickyTop();

    mm = gsap.matchMedia();
    mm.add({
      desk: '(min-width: 990px)',
      mob: '(max-width: 989px)',
      motion: '(prefers-reduced-motion: no-preference)'
    }, function (ctx) {
      var c = ctx.conditions;

      /* Barra fija "Quiero ser Builder" en móvil (no depende del movimiento) */
      var bar = document.querySelector('[data-bld-bar]');
      var heroCta = document.querySelector('[data-bld-hero-cta]');
      if (bar && heroCta && c.mob) {
        var barLink = bar.querySelector('a');
        var closing = document.querySelector('[data-bld-closing]');
        var setBar = function (on) { bar.classList.toggle('is-on', on); if (barLink) barLink.tabIndex = on ? 0 : -1; };
        ScrollTrigger.create({
          trigger: heroCta, start: 'bottom top',
          endTrigger: closing || document.body, end: closing ? 'top bottom' : 'bottom bottom',
          onToggle: function (self) { setBar(self.isActive); }
        });
      }

      if (!c.motion) return;

      /* Entrada por secciones: solo lo que está bajo el pliegue arranca oculto */
      if (!designMode) {
        var items = gsap.utils.toArray('.bld [data-bld-reveal]').filter(function (el) {
          return el.getBoundingClientRect().top > window.innerHeight * 0.92;
        });
        gsap.set(items, { autoAlpha: 0, y: 28 });
        ScrollTrigger.batch(items, {
          start: 'top 90%', once: true,
          onEnter: function (b) { gsap.to(b, { autoAlpha: 1, y: 0, duration: .7, stagger: .07, ease: 'power3.out', overwrite: true }); }
        });
        gsap.from('[data-bld-hero] > *', { y: 22, autoAlpha: 0, duration: .8, stagger: .08, ease: 'power3.out' });
      }

      var story = document.querySelector('[data-bld-story]');
      if (!story) return;

      if (c.desk) {
        var phone = story.querySelector('[data-bld-rail-phone]');
        var glow = story.querySelector('[data-bld-rail-glow]');
        var download = story.querySelector('[data-bld-download]');
        if (!phone) return;

        if (!designMode) gsap.from(phone, { y: 60, rotate: -10, autoAlpha: 0, duration: 1.1, ease: 'power3.out', delay: .15 });

        /* El teléfono viaja con el scroll: hero → principio → beneficios → descarga */
        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: story, start: 'top top',
            endTrigger: download || story, end: download ? 'center center' : 'bottom bottom',
            scrub: 0.8
          }
        });
        tl.to(phone, { rotate: 7, scale: .9, x: 18, ease: 'none' })
          .to(glow, { scale: .7, opacity: .55, ease: 'none' }, '<')
          .to(phone, { rotate: -7, scale: .92, x: -14, ease: 'none' })
          .to(glow, { scale: .85, opacity: .75, ease: 'none' }, '<')
          .to(phone, { rotate: 0, scale: 1.04, x: 0, ease: 'none' })
          .to(glow, { scale: 1.15, opacity: 1, ease: 'none' }, '<');

        /* Etiqueta junto al teléfono según el capítulo visible */
        var chip = story.querySelector('[data-bld-rail-chip]');
        if (chip) {
          gsap.utils.toArray(story.querySelectorAll('[data-bld-chip]')).forEach(function (ch) {
            var label = ch.getAttribute('data-bld-chip');
            if (!label) return;
            ScrollTrigger.create({
              trigger: ch, start: 'top 55%', end: 'bottom 55%',
              onToggle: function (self) {
                if (!self.isActive || chip.textContent === label) return;
                gsap.to(chip, { autoAlpha: 0, y: 8, duration: .18, overwrite: true, onComplete: function () {
                  chip.textContent = label;
                  gsap.to(chip, { autoAlpha: 1, y: 0, duration: .3, ease: 'power2.out' });
                } });
              }
            });
          });
        }
      }

      if (c.mob) {
        var heroPhone = story.querySelector('[data-bld-mphone="hero"] img');
        var downPhone = story.querySelector('[data-bld-mphone="download"] img');
        /* Hero: el teléfono se inclina y se aleja al salir */
        if (heroPhone) gsap.to(heroPhone, {
          rotate: 8, scale: .86, yPercent: -6, ease: 'none',
          scrollTrigger: { trigger: heroPhone, start: 'top 70%', end: 'bottom top', scrub: true }
        });
        /* Descarga: el teléfono llega y se endereza junto a las tiendas */
        if (downPhone) gsap.fromTo(downPhone,
          { yPercent: 28, rotate: -16, scale: .84 },
          { yPercent: 0, rotate: 0, scale: 1, ease: 'none',
            scrollTrigger: { trigger: downPhone.parentNode, start: 'top 95%', end: 'center 60%', scrub: 0.6 } });
      }
    });
  }

  onReady(function () {
    ensureGsap().then(function () {
      init();
      window.addEventListener('load', function () { window.ScrollTrigger.refresh(); });
      /* Editor de temas: reiniciar cuando cambia una sección */
      ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (evt) {
        document.addEventListener(evt, function () { setTimeout(init, 60); });
      });
    }).catch(function () { /* sin GSAP: la página queda estática y completa */ });
  });
})();
